import React, { useState } from 'react';
import '../../../../../../Assets/styles/LandingStyles/LandingComponentsStyles/BeginnersGuideStyles/SudokuBasicsStyles/SudokuBasics.css';
import { useLanguage } from 'Core/Translations/LanguageContext';

import TutorialStep1 from './TutorialSteps/TutorialStep1';
import TutorialStep2 from './TutorialSteps/TutorialStep2';
import TutorialStep3 from './TutorialSteps/TutorialStep3';
import Congratulations from './Congratulations';
import SudokuVideo from './SudokuVideo';
import { scrollToTop } from '../../ScrollToTop'; // update the import path as needed

interface SudokuBasicsProps {
    onSwitchTab: (tab: 'origins' | 'basics' | 'rules') => void;
}

export const SudokuBasics: React.FC<SudokuBasicsProps> = ({ onSwitchTab }) => {
    const { t } = useLanguage();
    const [currentStep, setCurrentStep] = useState(1);
    const [nextButtonActive, setNextButtonActive] = useState(false);

    const renderStep = () => {
        switch (currentStep) {
            case 1:
                return <SudokuVideo />;
            case 2:
                return <TutorialStep1 />;
            case 3:
                return <TutorialStep2 />;
            case 4:
                return <TutorialStep3 />;
            case 5:
                return <Congratulations onSwitchTab={onSwitchTab} />;
            default:
                return <SudokuVideo />;
        }
    };

    const handleNextClick = () => {
        // Trigger active styling for a visual effect.
        setNextButtonActive(true);
        setTimeout(() => {
            setNextButtonActive(false);
        }, 200);

        if (currentStep < 5) {
            setCurrentStep(currentStep + 1);
        } else {
            // When on step 5, switch to the game rules tab.
            onSwitchTab('rules');
        }
    };

    return (
        <div className="tutorial-container">
            <div className="main-content">
                {renderStep()}
            </div>

            <footer className="footer">
                <div className="button-container">
                    <button
                        className="navigation-button"
                        onClick={() => {
                            setCurrentStep(Math.max(1, currentStep - 1));
                            scrollToTop();
                        }}
                        disabled={currentStep === 1}
                    >
                        {t.beginnersGuide.controller.previous}
                    </button>
                    <span className="progress-indicator">
                        {currentStep}{t.beginnersGuide.controller.of}5
                    </span>
                    <button
                        className={`navigation-button ${nextButtonActive ? 'active' : ''} ${currentStep === 5 ? 'final-step' : ''}`}
                        onClick={() => {
                            handleNextClick();
                            scrollToTop();
                        }}
                    >
                        {currentStep === 5 ? t.beginnersGuide.controller.gameRules : t.beginnersGuide.controller.next}
                    </button>
                </div>
            </footer>
        </div>
    );
};

export default SudokuBasics;